export const LogoText = () => (
  <a href="/" className="flex items-center">
    {/* <span className="font-adobeAldineItalic text-3xl pl-2 text-violet-800 text-shadow-2xs text-shadow-gray-300  whitespace-nowrap dark:text-purple-200 hover:text-purple-600 dark:hover:text-purple-400">
      Harmony of Soul
    </span> */}

    {/* <span className="font-adobeAldine text-3xl pl-2 font-bold text-purple-800 whitespace-nowrap dark:text-purple-200 hover:text-purple-600 dark:hover:text-purple-400">
      Harmony of Soul
    </span> */}
    <span className="font-baskervville text-2xl pl-2 font-bold text-violet-900 text-shadow-2xs text-shadow-gray-400 dark:text-shadow-none whitespace-nowrap dark:text-violet-100 hover:text-violet-700 dark:hover:text-violet-400">
      Harmony of Soul
    </span>
  </a>
);
export default LogoText;
